<template>
  <div class="m-edition-section-content-info-submenu m-edition-section-content-info-submenu-asset">
    <ul>
      <li>
        <router-link
          :class="[$t('mEditionMenu.asset.activation.subject') === $route.params.subject
            && $t('mEditionMenu.asset.activation.children.activate.subedition') === $route.params.subedition
              ? 'submenu-item-active submenu-item-active-assets'
              : '']"
          :to="`/${$t('rPaths.asset')}/${this.$route.params.id}/${$t('mEditionMenu.asset.activation.subject')}/${$t('mEditionMenu.asset.activation.children.activate.subedition')}`"
        >
          {{ $t('mEditionMenu.asset.activation.children.activate.subText') }}
        </router-link>
      </li>
      <li>
        <router-link
         :class="[$t('mEditionMenu.asset.activation.subject') === $route.params.subject
            && ($t('mEditionMenu.asset.activation.children.sendingOfDeliverables.subedition') === $route.params.subedition
              || $t('mEditionMenu.asset.activation.children.create.subedition') === $route.params.subedition
              || $t('mEditionMenu.asset.activation.children.edit.subedition') === $route.params.subedition)
              ? 'submenu-item-active submenu-item-active-assets'
              : '']"
          :to="`/${$t('rPaths.asset')}/${this.$route.params.id}/${$t('mEditionMenu.asset.activation.subject')}/${$t('mEditionMenu.asset.activation.children.sendingOfDeliverables.subedition')}`"
        >
          {{ $t('mEditionMenu.asset.activation.children.sendingOfDeliverables.subText') }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionAssetActivationSubMenu'
}

</script>
